import { z } from 'zod';
import { FlowRunExecutionMode } from '../../../flowRun/executionMode.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
/* eslint-disable @typescript-eslint/no-deprecated -- the block schema must reference the deprecated run-execution mode while it remains supported */
export const FlowAuthorizationSubmissionBlockConfigSchema = z.object({
    mockScenarioId: z.string().optional(),
    patientLastName: z.string().optional(),
    runMode: z.enum(FlowRunExecutionMode).default(FlowRunExecutionMode.Live),
});
export const FlowAuthorizationSubmissionBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.AuthorizationSubmission),
    config: FlowAuthorizationSubmissionBlockConfigSchema,
});
//# sourceMappingURL=config.js.map